import { Icon } from '@natera/material/lib/icon'
import { trackEvent } from '~/shared/lib/analytics'
import { cn } from '~/shared/lib/cn'
import type { AmountType } from '../../../model'

interface AmountTypeToggleProps {
  value: AmountType
  onChange: (value: AmountType) => void
}

export function AmountTypeToggle({ value, onChange }: AmountTypeToggleProps) {
  return (
    <div className="border-divider flex shrink-0 overflow-hidden rounded-xs border">
      <button
        type="button"
        className={cn(
          'focus-visible:bg-primary-focused flex h-4 w-[17px] cursor-pointer items-center justify-center outline-none',
          'border-divider border-y-0 border-r border-l-0',
          value === 'cents'
            ? 'bg-primary-selected text-primary-main'
            : 'text-text-secondary bg-transparent',
        )}
        onClick={() => {
          if (value !== 'cents') {
            trackEvent('eob_amount_type_toggled', { amount_type: 'cents' })
            onChange('cents')
          }
        }}
        title="Dollar amount"
      >
        <Icon
          className="text-[16px]"
          children="attach_money"
        />
      </button>
      <button
        type="button"
        className={cn(
          'focus-visible:bg-primary-focused flex size-4 cursor-pointer items-center justify-center border-none outline-none',
          value === 'percentage'
            ? 'bg-primary-selected text-primary-main'
            : 'text-content-medium-emphasis bg-transparent',
        )}
        onClick={() => {
          if (value !== 'percentage') {
            trackEvent('eob_amount_type_toggled', { amount_type: 'percentage' })
            onChange('percentage')
          }
        }}
        title="Percentage"
      >
        <Icon
          className="text-[16px]"
          children="percent"
        />
      </button>
    </div>
  )
}
